import { HTTP_INTERCEPTORS, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { TokenStorageService } from '../_service/token-storage.service';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from '../_service/user.service';
import { CookieService } from 'ngx-cookie-service';


const TOKEN_HEADER_KEY = 'Authorization';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private _sessionId: any;
  constructor(private ngxService1: NgxUiLoaderService,
    private token: TokenStorageService, private _service: CommonService
    //  , private cookieService: CookieService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //this.ngxService1.start(); // start foreground loading with 'default' id 
    if (!window.navigator.onLine) {
      // if there is no internet, throw a HttpErrorResponse error
      // since an error is thrown, the function will terminate here
      return Observable.throw(new HttpErrorResponse({ error: 'Internet is required.' }));

    }

    const cookieheaderName = 'XSRF-TOKEN';

    ////this._sessionId = this.cookie.set(cookieheaderName, this.token.randomString(140), 1, '', '', true, 'Strict');
    //var csrfToken = this.cookieService.get('X-XSRF-TOKEN');

    ////let csrfToken = this.tokenExtractor.getToken() as string;
    //if (csrfToken !== null && !req.headers.has(cookieheaderName)) {
    //  req = req.clone({ headers: req.headers.set(cookieheaderName, csrfToken) });
    //}
    //return next.handle(req);

    let authReq = req;

    //authReq = authReq.clone({
    //  withCredentials: true
    //});

    const token = this.token.getToken();
    //authReq = authReq.clone({
    //  withCredentials: true,
    //});
    debugger

    //this._sessionId= authReq.headers.getAll('set-cookie');

    //let cookieValue = this.cookieService.get(this._sessionId);
    //let cookieValue = this.cookieService.get(this._sessionId);

    //let cookieValue = this.cookieService.set('Cookies1', this._sessionId);

    //signup
    
    debugger

    //if (authReq.url.includes('https://mati.ezipay.global/api/MerchantSignUp/ThirdPartySignup')) {
    //  authReq = authReq.clone({ headers: authReq.headers.set(TOKEN_HEADER_KEY, 'Basic TWVyY2hhbnQuMzM2MTo3ZDM4YTFjOC04ZDQzLTQyN2MtOGViOS04YzU0MjIxYTU2ZTM=') });
    //} //make payment request

    //else if (authReq.url.includes('https://testnew.ezipay.global/merchant/payment-req')) {
    //  authReq = authReq.clone({ headers: authReq.headers.set(TOKEN_HEADER_KEY, 'Basic TWVyY2hhbnQuMzM2MTo3ZDM4YTFjOC04ZDQzLTQyN2MtOGViOS04YzU0MjIxYTU2ZTM=') });
    //}
    //else if (authReq.url.includes('https://testnew.ezipay.global/api/ThirdPartyGamingMerchant/add-money')) {
    //  authReq = authReq.clone({ headers: authReq.headers.set(TOKEN_HEADER_KEY, 'Basic TWVyY2hhbnQuMzM2MTo3ZDM4YTFjOC04ZDQzLTQyN2MtOGViOS04YzU0MjIxYTU2ZTM=') });
    //}
    //else
      if (token != null) {
        authReq = authReq.clone({ headers: authReq.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
        authReq = authReq.clone({ headers: authReq.headers.set('Content-Type', 'application/json') });
    }
    

    //if (authReq.url.indexOf(environment.apiBaseUrl + '/Login/UploadProfileImage') === -1
    //  && authReq.url.indexOf(environment.apiBaseUrl + '/Login/Kyc') === -1
    //  && authReq.url.indexOf(environment.apiBaseUrl + '/PaymentCards/card-upload') === -1
    //  && authReq.url.indexOf(environment.apiBaseUrl + '/Login/MerchantDoc') === -1

    //) {
    //  authReq = authReq.clone({ headers: authReq.headers.set('Content-Type', 'application/json') });
    //  //authReq = authReq.clone({ headers: authReq.headers.set('Access-Control-Allow-Origin', '*') });
    //  //authReq = authReq.clone({ headers: authReq.headers.set('Access-Control-Allow-Origin', 'http://localhost:4200/#/Home') });
    //}
    //else {
    //  // authReq = authReq.clone({ headers: authReq.headers.set('Accept', 'application/json') });
    //  //authReq = authReq.clone({ headers: authReq.headers.set('Access-Control-Allow-Origin', '*') });

    //}
    authReq = authReq.clone({ headers: authReq.headers.set('Access-Control-Allow-Origin', '*') });
    debugger;
    return next.handle(authReq).pipe(
      map((event: HttpEvent<any>) => {

        if (event instanceof HttpResponse) {
          // ////////console.log('response--->>>', event);
          // this.errorDialogService.openDialog(event);
        }
        //this.ngxService1.stop(); // stop foreground loading with 'default' id

        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        // let data = {};
        // data = {
        //     reason: error && error.error.reason ? error.error.reason : '',
        //     status: error.status
        // };


        ////////console.log('error--->>>', error);
        // this.errorDialogService.openDialog(data);
        if (error && error.status === 401) {
          this._service.callMethodOfSecondComponent(); //logout();

        }
        let errorPayload = JSON.parse(error.message);
        //ToDo: apply your handling logic e.g.:
        //////////console.log(errorPayload[0].description
        ////////console.log(error.error);

        this.ngxService1.stop(); // stop foreground loading with 'default' id
        return throwError(error);
      })
    );
  }
}

//export const authInterceptorProviders = [
//  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
//  { provide: HttpXsrfTokenExtractor, useClass: AuthInterceptor }
//];
